'use client';
import React, { useState } from 'react';
import { useRouter } from 'next/navigation';
import Image from 'next/image';
import { Loader2 } from 'lucide-react';

export default function RootPage() {
  const router = useRouter();
  const [loading, setLoading] = useState(false);

  const handleGetStarted = () => {
    if (loading) return;
    setLoading(true);
    router?.push('/lead-management');
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center relative overflow-hidden bg-gradient-to-br from-slate-900 via-blue-950 to-slate-900">
      {/* Decorative background blobs */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -left-40 w-[600px] h-[600px] rounded-full bg-blue-600/20 blur-3xl" />
        <div className="absolute -bottom-40 -right-40 w-[600px] h-[600px] rounded-full bg-blue-800/20 blur-3xl" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full bg-blue-700/10 blur-3xl" />
      </div>
      {/* Grid overlay */}
      <div
        className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage: 'linear-gradient(rgba(255,255,255,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.5) 1px, transparent 1px)',
          backgroundSize: '60px 60px',
        }}
      />
      {/* Content */}
      <div className="relative z-10 flex flex-col items-center gap-8 px-6 text-center">
        {/* NOC Logo */}
        <div className="flex items-center justify-center">
          <Image
            src="/assets/images/959b4801-76fd-48dd-86f9-f9f19ccf99f3-1776971576980.png"
            alt="NOC - Not OnContact logo"
            width={220}
            height={110}
            className="drop-shadow-2xl"
            priority
          />
        </div>

        {/* Get Started button */}
        <button
          onClick={handleGetStarted}
          disabled={loading}
          className="mt-2 px-10 py-4 bg-blue-600 hover:bg-blue-500 active:bg-blue-700 disabled:opacity-70 disabled:cursor-not-allowed text-white text-lg font-semibold rounded-2xl shadow-lg shadow-blue-900/50 transition-all duration-200 hover:scale-105 active:scale-95 disabled:hover:scale-100 flex items-center gap-3 min-w-[180px] justify-center"
        >
          {loading ? (
            <>
              <Loader2 size={20} className="animate-spin" />
              Loading…
            </>
          ) : (
            'Get Started'
          )}
        </button>

        <p className="text-slate-500 text-xs mt-2">No login required · Internal preview</p>
      </div>
    </div>
  );
}